import { IRoute } from "src/pages/Router/routes";
import CreateSupportTicketPage from "src/pages/Customer/Support/CreateSupportTicketPage";
import { Icons } from "src/library/components/Icon/types";

import OrderPlaced from "./OrderPlaced";
import ViewOrderPage from "./ViewOrderPage";
import CreateOrderPage from "./CreateOrderPage";
import OrderCheckoutPage from "./OrderCheckoutPage";
import ThreeDSecurePage from "./3DSecurePage";

export const CustomerOrders: IRoute[] = [
  {
    exact: true,
    path: "/orders/reminder/:orderDeliveryDate/branch/:branchId",
    pageComponent: CreateOrderPage,
    title: "Creating %ORDER%",
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/order-placed",
    pageComponent: OrderPlaced,
    title: "%ORDER% Placed",
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/order-placed",
    pageComponent: OrderPlaced,
    title: "%ORDER% Placed",
    menuType: "ADMIN_MAIN",
    roles: [ "admin" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/3d-secure",
    pageComponent: ThreeDSecurePage,
    title: "%ORDER% Placed",
    menuType: "NONE",
    roles: [ "admin", "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/van-sales/orders/:orderId/order-placed",
    pageComponent: OrderPlaced,
    title: "%ORDER% Placed",
    menuType: "ADMIN_VAN_SALES",
    roles: [ "admin" ],
    modules: [ "van-sales-ordering" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/raise-ticket",
    pageComponent: CreateSupportTicketPage,
    title: "Raise Support Ticket",
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/raise-ticket",
    pageComponent: CreateSupportTicketPage,
    title: "Raise Support Ticket",
    menuType: "ADMIN_MAIN",
    roles: [ "admin" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId",
    pageComponent: ViewOrderPage,
    title: "%ORDER% Details",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION" ],
    contextMenu: {
      ORDER_PRODUCT_SELECTION: {
        hidden: false,
        icon: Icons.CART,
        title: "Checkout"
      }
    },
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId",
    pageComponent: ViewOrderPage,
    title: "%ORDER% Details",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION" ],
    contextMenu: {
      ORDER_PRODUCT_SELECTION: {
        icon: Icons.CART,
        title: "Checkout"
      }
    },
    menuType: "ADMIN_MAIN",
    roles: [ "admin" ],
    hidden: true,
    privateRoute: true
  },
  {
    exact: true,
    path: "/orders/:orderId/checkout",
    pageComponent: OrderCheckoutPage,
    title: "%ORDER% Checkout",
    menuType: "MAIN",
    roles: [ "admin", "customer" ],
    hidden: true,
    privateRoute: true
  }
];

export default CustomerOrders;
